import React from 'react'
import { logo } from '../data/constant'


export default function Loader() {
    return (
        <div id="spinner" className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
            <div className="spinner-grow text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
                <span className="sr-only"> <img src={logo} alt="Loading icon"  /></span>
            </div>
        </div>
    )
}
